import { ThemeProvider } from '@mui/styles';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
// import Card from '@mui/material/Card';
import CircularLoading from '../components/CircularLoading';
import { Product } from '../components/Product';
import { GetProductCatalog } from '../services/Product';
import { GetRole, GetToken, GuestLogin, Me, SetToken, SetUser, UpdateToken } from '../services/Session';
import '../styles/style.css';
import theme from '../styles/theme';

import dayjs from 'dayjs';

const Logo =
  '/assets/images/logo-pernik-hsi.png';
const FilterIcon = '/assets/svg/filter.svg';
const HomeIcon = '/assets/svg/home.svg';
const CartIcon = '/assets/svg/cart.svg';
const TransactionIcon = '/assets/svg/transaction.svg';
const MessageIcon = '/assets/svg/message.svg';
const AccountIcon = '/assets/svg/account.svg';
const DashboardIcon = '/assets/svg/dashboard.svg';

const isFilterFeatureAvailable = false;
const isCartFeatureAvailable = false;
const isMessageFeatureAvailable = false;

const PreOrderInternal = () => {
  const [loading, setLoading] = useState(false);
  const [catalog, setCatalog] = useState({
    count: 0,
    page_context: {
      page: 0,
      per_page: 0,
      total_pages: 0,
    },
    results: [],
  });
  const [highlights, setHighlights] = useState({
    count: 0,
    page_context: {
      page: 0,
      per_page: 0,
      total_pages: 0,
    },
    results: [],
  });
  const retryCountRef = useRef(0);

  const handleRefresh = async (callBack) => {
    retryCountRef.current++;

    if (retryCountRef.current < 5) {
      if (GetToken().refresh_token) {
        try {
          const { data } = await UpdateToken();
          handleRetry(data.token, callBack);
        } catch {
          const { data } = await GuestLogin();
          handleRetry(data.token, callBack);
        }
      } else {
        const { data } = await GuestLogin();
        handleRetry(data.token, callBack);
      }
    }
  };

  const handleRetry = async (token, cb) => {
    try {
      const { data } = await Me(SetToken(token).access_token);

      SetUser(data);
      setTimeout(cb, 1e3);
    } catch {}
  };

  const handleError = (err, funcName) => {
    if (err.response) {
      if (err.response.status === 401) {
        handleRefresh(funcName);
      } else if (err.response.data?.error?.message) {
        alert(err.response.data.error.message);
      } else {
        alert('gagal terhubung ke server');
      }
    } else {
      alert('gagal terhubung ke server');
    }
  };

  const getAvailableProducts = (items) => {
    return items.filter((p) => p.quantity.available > 0);
  };

  const getCatalog = async () => {
    setLoading(true);
    try {
      const { data } = await GetProductCatalog({ 
        'is_active': true, 
        'type.$nin': 'certificate,pre_order',
        'sorts': 'sort_number',
      });

      setLoading(false);
      setCatalog(data);
      if (highlights.count==0 && data.results && data.results.length>0) {
        for (let i = 0; i < data.results.length; i++) {
          if (data.results[i].code=='sarung-rs') {
            setHighlights({
              count: 1,
              page_context: {
                page: 1,
                per_page: 1,
                total_pages: 1,
              },
              results: [
                data.results[i],
              ],
            })
          }
        }
      }
    } catch (err) {
      setLoading(false);
      handleError(err, getCatalog);
    }
  };

  const getHighlights = async () => {
    setLoading(true);
    try {
      const { data } = await GetProductCatalog({ 
        'is_active': true,
        'type.$in': 'pre_order_internal',
        'open_at.$lte': dayjs().format(),
        'closed_at.$gte': dayjs().format(),
        'sorts': 'sort_number',
      });

      setLoading(false);
      setHighlights(data);
    } catch (err) {
      setLoading(false);
      handleError(err, getHighlights);
    }
  };

  useEffect(() => {
    const getData = async () => {
      // await handleRefresh(getCatalog);
      await getHighlights();
    };

    getData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="header">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="./about.html"
          className="center"
          style={{ padding: 10, textAlign: 'center' }}
        >
          <img alt="icon" src={Logo} style={{ height: 45 }} />
        </a>
        {isFilterFeatureAvailable && (
          <Link
            to="/"
            style={{
              position: 'absolute',
              height: 24,
              width: 60,
              top: 18,
              right: 10,
            }}
          >
            <img alt="icon" src={FilterIcon} />
          </Link>
        )}
      </div>
      <div className="wrapper">
        {/*<Card className="order-card" style={{ width: '90%', padding: 20, marginTop: 20 }}>
          <div className="center">
            Mohon maaf toko tutup sementara libur hari raya Idul Fitri 1443H
          </div>
        </Card>*/}
        {loading ? (
          <div className="center" style={{ width: 40, height: 40 }}>
            <CircularLoading />
          </div>
        ) : (
          <>
            <div className="highlights">
              {highlights.results.map((product) => (
                <Product key={product.id} data={product} />
              ))}
            </div>
            <div className="products">
              {getAvailableProducts(catalog.results).map((product) => (
                <Product key={product.id} data={product} />
              ))}
            </div>
          </>
        )}
      </div>
      <div className="footer">
        <Link to="/" style={{ width: 60 }}>
          <img alt="icon" src={HomeIcon} />
        </Link>
        {isCartFeatureAvailable && (
          <Link to="/keranjang-belanja" style={{ width: 60 }}>
            <img alt="icon" src={CartIcon} />
          </Link>
        )}
        {GetRole().id > 2 && (
          <Link to="/dasbor" style={{ width: 60 }}>
            <img alt="icon" src={DashboardIcon} />
          </Link>
        )}
        <Link to="/transaksi" style={{ width: 60 }}>
          <img alt="icon" src={TransactionIcon} />
        </Link>
        {isMessageFeatureAvailable && (
          <Link to="/pesan" style={{ width: 60 }}>
            <img alt="icon" src={MessageIcon} />
          </Link>
        )}
        <Link to="/profil" style={{ width: 60 }}>
          <img alt="icon" src={AccountIcon} />
        </Link>
      </div>
    </ThemeProvider>
  );
};

export default PreOrderInternal;
